export class GestorRegistro {
    constructor(
        public email: string,
        public senhaSugerida: string,
        public numeroDocumento: string,
        public dataNascimento: Date,
        public telefone: string
    ) { }
}
